import { render, staticRenderFns } from "./VDate.vue?vue&type=template&id=2e31bdb7&"
import script from "./VDate.vue?vue&type=script&lang=js&"
export * from "./VDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports